import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';

const ca1 = 'ca1';
const ca2 = 'ca2';
const ca3 = 'ca3';
const cb1 = 'cb1';
const cb2 = 'cb2';
const cb3 = 'cb3';
const cc1 = 'cc1';
const cc2 = 'cc2';
const cc3 = 'cc3';
const cd1 = 'cd1';
const cd2 = 'cd2';
const cd3 = 'cd3';
const ce1 = 'ce1';
const ce2 = 'ce2';
const ce3 = 'ce3';

export const CaValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'ca1',
        value: ca1,
        tekst: 'ca1',
    },
    {
        id: 'ca2',
        value: ca2,
        tekst: 'ca2',
    },
    {
        id: 'ca3',
        value: ca3,
        tekst: 'ca3',
    }
]

export const CbValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'cb1',
        value: cb1,
        tekst: 'cb1',
    },
    {
        id: 'cb2',
        value: cb2,
        tekst: 'cb2',
    },
    {
        id: 'cb3',
        value: cb3,
        tekst: 'cb3',
    }
]

export const CcValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'cc1',
        value: cc1,
        tekst: 'cc1',
    },
    {
        id: 'cc2',
        value: cc2,
        tekst: 'cc2',
    },
    {
        id: 'cc3',
        value: cc3,
        tekst: 'cc3',
    }
]

export const CdValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'cd1',
        value: cd1,
        tekst: 'cd1',
    },
    {
        id: 'cd2',
        value: cd2,
        tekst: 'cd2',
    },
    {
        id: 'cd3',
        value: cd3,
        tekst: 'cd3',
    }
]

export const CeValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'ce1',
        value: ce1,
        tekst: 'ce1',
    },
    {
        id: 'ce2',
        value: ce2,
        tekst: 'ce2',
    },
    {
        id: 'ce3',
        value: ce3,
        tekst: 'ce3',
    }
]

export default {
    ca1: ca1,
    ca2: ca2,
    ca3: ca3,
    cb1: cb1,
    cb2: cb2,
    cb3: cb3,
    cc1: cc1,
    cc2: cc2,
    cc3: cc3,
    cd1: cd1,
    cd2: cd2,
    cd3: cd3,
    ce1: ce1,
    ce2: ce2,
    ce3: ce3
};